export default __webpack_public_path__ + "static/media/icon-visible-20.0270500a.svg";